import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.textareaTargets.forEach(textarea => this.setupTextarea(textarea))
  }

  textareaTargetConnected(textarea) {
    this.setupTextarea(textarea)
  }

  setupTextarea(textarea) {
    // Set initial height to 2 lines
    const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight)
    const padding = parseInt(window.getComputedStyle(textarea).paddingTop) +
                   parseInt(window.getComputedStyle(textarea).paddingBottom)
    const initialHeight = (lineHeight * 2) + padding

    textarea.style.height = `${initialHeight}px`
    textarea.style.overflow = 'hidden'

    // Auto-resize on input
    textarea.addEventListener('input', () => this.resize(textarea))

    // Initial resize in case there's pre-existing content
    this.resize(textarea)
  }

  resize(textarea) {
    // Reset height to get accurate scrollHeight
    textarea.style.height = 'auto'

    // Set height to scrollHeight (content height)
    const newHeight = Math.max(textarea.scrollHeight, this.getMinHeight(textarea))
    textarea.style.height = `${newHeight}px`
  }

  getMinHeight(textarea) {
    const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight)
    const padding = parseInt(window.getComputedStyle(textarea).paddingTop) +
                   parseInt(window.getComputedStyle(textarea).paddingBottom)
    return (lineHeight * 2) + padding // Minimum 2 lines
  }
}